import script from "./newproduct.vue?vue&type=script&setup=true&lang=js"
export * from "./newproduct.vue?vue&type=script&setup=true&lang=js"

import "./newproduct.vue?vue&type=style&index=0&id=31fc1538&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fc1538"]])

export default __exports__